import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';

import { Add as BENE_ADD } from 'Components/Api/UpiBeneficiaryAPI';
import { UpiTransferWithSender as UPI_TRANSFER } from 'Components/Api/UPITransfer';
import { Select as BENE_SELECT } from 'Components/Api/UpiBeneficiaryAPI';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import ReactTable from 'Components/ReactTable/ReactTable';
import { SelectDMTForReceiptForWeb as TRANSACTION_RECEIPT } from 'Components/Api/TransactionReportAPI';

import {
    Container,
    Grid,
    Paper,
    Button,
    Box,
    CircularProgress,
    Hidden
} from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';

import AutoSubmitIFSCForBeneAdd from 'Components/Helper/AutoSubmitIFSCForBeneAdd';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import { UPITRANSFER_CODE } from 'Components/Helper/Messages';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { UPITransferPrint } from 'Components/Print/UPITransferPrint';

const CustomContainer = HOCLoader(Container);

export const BeneficiaryAdd = () => {
    const location = useLocation();

    const ActiveUPITransferName = location?.state?.ActiveUPITransferName;
    const formRef = useRef();
    const classes = commonStyle();
    const history = useHistory();

    const [mainColumns, setMainColumns] = useState([]);
    const [list, setList] = useState([]);
    const [isReadOnly, setReadOnly] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [serviceCode, setserviceCode] = useState(UPITRANSFER_CODE);

    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const Mobile = location?.state?.Mobile;
    const UpiSenderID = location?.state?.UpiSenderID;

    const [isAddOnly, setIsAddOnly] = useState(false);

    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [ResponseAlert, setResponseAlert] = useState({});
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [printData, setPrintData] = useState(null);
    const [isPrintOpen, setIsPrintOpen] = useState(false);
    const [isUPIVerify] = useState(localStorage.getItem('IsUPIVerify'));
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }

    const [bankDefault, setBankDefault] = useState({
        Name: 'Select Bank',
        DefaultIFSC: ''
    });

    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        UpiSenderID: UpiSenderID,
        Name: '',
        Bank: bankDefault,
        DefaultIFSC: '',
        UpiID: '',
        IFSC: '',
        isAddOnly: false,
        IsNameVerified: false
    });

    const reset = (
        BeneficiaryName
    ) => {
        setBankDefault({
            Name: 'Select Bank',
            DefaultIFSC: ''
        });
        setFormObject({
            Mobile: Mobile,
            UpiSenderID: UpiSenderID,
            Name: '',
            UpiID: '',
            isAddOnly: false,
            IsNameVerified: false,
            BeneName: BeneficiaryName,
        });
    };

    useEffect(() => {
        selectBene();
        createColumns();
        fetchConsumerNumberFontSize();
    }, []);

    useEffect(() => {
        setLoading(true);
    }, [serviceCode]);

    const selectBene = async () => {
        if (UpiSenderID === undefined) return;

        if (UpiSenderID === '') return;

        var beneReqObj = JSON.stringify({
            UpiSenderID: UpiSenderID
        });

        var response = await BENE_SELECT(beneReqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        setList(data);
    };

    const Print = (VendorID) => {
        SelectPrintData(VendorID);
    };

    const SelectPrintData = async (TransactionMasterID) => {
        var req = {
            ID: TransactionMasterID
        };
        var request = JSON.stringify(req);
        setLoading(true);
        const { isAuthorized, status, data } = await TRANSACTION_RECEIPT(
            request
        );
        setLoading(false);
        if (!isAuthorized) LOGOUT();
        var d = JSON.parse(data);
        setPrintData(d);
        setIsPrintOpen(true);
    };

    const submithandle = async (
        values,
        { setSubmitting, resetForm, setFieldValue }
    ) => {
        setResponseMessage('');

        if (values.isAddOnly === true) {
            setIsAddOnly(true);
            core_bene_add(values, values.Name);
            return;
        }

        confirmAlertRequest.Mobile = values.Mobile;
        confirmAlertRequest.Name = values.Name;
        confirmAlertRequest.UpiID = values.UpiID;
        confirmAlertRequest.UpiBeneficiaryID = values.Mobile;
        confirmAlertRequest.UpiSenderID = values.Mobile;
        confirmAlertRequest.Amount = 1;
        confirmAlertRequest.RechargePin = '';
        confirmAlertRequest.Through = 'WEB';
        confirmAlertRequest.IsVerify = true;
        confirmAlertRequest.ActiveUPI = ActiveUPITransferName;

        var requestObj = JSON.stringify(confirmAlertRequest);

        setLoading(true);

        let response = '';

        response = await UPI_TRANSFER(requestObj); 
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            let data = JSON.parse(response.data);
            setResponseMessage(data.Message);
            setIsError(true);
            return;
        }

        let dataSuccess = JSON.parse(response.data);

        setSeverity('success');
        setResponseMessage(dataSuccess.Message);
        //setStatus(dataSuccess.Status);
        setResponseAlert(dataSuccess);
        setIsResponseAlertOpen(true);

        if (dataSuccess.Status === 'SUCCESS') {
            setReadOnly(true);
            setFieldValue('IsNameVerified', true);
        }      
        setFieldValue('Name', dataSuccess.BeneficiaryName);    
    };

    const core_bene_add = async (values, beneName) => {
        setResponseMessage('');
        var request = {
            Name: beneName,
            UpiID: values.UpiID,
            UpiSenderID: values.UpiSenderID,
            SenderMobile: values.Mobile,
            IsNameVerified: values.IsNameVerified,
            ActiveUPITransferName: ActiveUPITransferName
        };

        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await BENE_ADD(requestObj);
        if (!response.isAuthorized) LOGOUT();
        setLoading(false);

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setSeverity('success');

        var param = {
            UpiBeneficiaryID: data.UpiBeneficiaryID,
            Mobile: values.Mobile,
            ActiveUPITransferName: ActiveUPITransferName
        };
        if (
            data.Message === 'OTP sent on sender number' ||
            data.Message === 'Please verify beneficiary OTP'
        ) {
            history.push('/UPIBeneficiaryVerify', param);
            return;
        } else {
            let param1 = {
                Mobile: values.Mobile,
                ActiveUPITransferName: ActiveUPITransferName
            };
         
            history.push('/UPISenderSearch', param1);
            return;
        }
    };
    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'UpiBeneficiaryID',
            srno: true
        });
        columns.push({
            label: 'Name',
            name: 'Name'
        });

        columns.push({
            label: 'UpiID',
            name: 'UpiID'
        });

        setMainColumns(columns);
    };

    const FormValidationSchema = Yup.object({
        Bank: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'bank')
            .required(PLEASE_SELECT_VALID + 'bank')

            .shape({
                Name: Yup.string()
                    .nullable(PLEASE_SELECT_VALID + 'bank')
                    .required(PLEASE_SELECT_VALID + 'bank')
            }),

        Mobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile'),
        isAddOnly: Yup.boolean(),

        Name: Yup.string().when(['isAddOnly'], {
            is: (isAddOnly) => isAddOnly,
            then: Yup.string().required(PLEASE_PROVIDE_VALID + 'name')
        })
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <AutoSubmitIFSCForBeneAdd
                                        callback={() => {
                                            //GetBranch(values, setFieldValue);
                                        }}
                                    />
                                    <h2 className={classes.PaperHead_h2}>
                                        Beneficiary Add
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Mobile"
                                                        name="Mobile"
                                                        type="text"
                                                        length={10}
                                                        readOnly={true}
                                                        placeholder="Mobile"
                                                    />

                                                    <Hidden xsUp>
                                                        <MaterialTextField
                                                            label="IsNameVerified"
                                                            name="IsNameVerified"
                                                            type="text"
                                                            placeholder="IsNameVerified"
                                                        />
                                                    </Hidden>
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="UPI ID."
                                                        name="UpiID"
                                                        autoComplete="new-password"
                                                        type="text"
                                                        //length={20}
                                                        placeholder="UPI ID."
                                                        typed_length={1}
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>
                                                {isUPIVerify === 'true' && (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={3}
                                                        lg={3}
                                                    >
                                                        <div
                                                            className={
                                                                classes.SubmitWrapper
                                                            }
                                                        >
                                                            <Button
                                                                type="submit"
                                                                title="Verify"
                                                                className={
                                                                    classes.CustomPrimaryButtonStyle
                                                                }
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    setFieldValue(
                                                                        'isAddOnly',
                                                                        false
                                                                    );
                                                                    handleSubmit(
                                                                        e
                                                                    );
                                                                }}
                                                                disabled={
                                                                    loading
                                                                }
                                                            >
                                                                Verify
                                                            </Button>
                                                            {loading && (
                                                                <CircularProgress
                                                                    size={24}
                                                                    className={
                                                                        classes.buttonProgress
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                    </Grid>
                                                )}
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Bene Name"
                                                        name="Name"
                                                        type="text"
                                                        placeholder="Bene Name"
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                                style={{
                                                    marginLeft: '10px'
                                                }}
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Add"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddOnly',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                    disabled={loading}
                                                >
                                                    Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>

                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                                onClick={() => {
                                                    reset();
                                                }}
                                            >
                                                Reset
                                            </Button>

                                            <Button
                                                type="reset"
                                                title="Cancel"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                                onClick={(e) => {
                                                    var param = {
                                                        Mobile: values.Mobile
                                                    };

                                                    history.push(
                                                        '/UPISenderSearch',
                                                        param
                                                    );
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={8}
                                lg={8}
                                className="lastrecharges"
                            >
                                <h2 className={classes.PaperHead_h2}>
                                    Beneficiary List
                                </h2>
                                <ReactTable data={list} columns={mainColumns} />
                            </Grid>
                        </Grid>
                    );
                }}
            />

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    isPrint={true}
                    title={ResponseAlert.Status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                    }}
                    PrintButtonClick={() => {
                        Print(ResponseAlert.VendorID);
                        setIsResponseAlertOpen(false);
                    }}
                />
            ) : null}

            {isPrintOpen ? (
                <UPITransferPrint
                    isOpen={isPrintOpen}
                    title="UPI Transfer Print"
                    request={printData}
                    positiveButtonClick={() => {
                        setIsPrintOpen(false);
                    }}
                    negativeButtonClick={() => {
                        setIsPrintOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
